import Page from './Page'

export default class Home extends Page {
  onEnter() {
    super.onEnter()
  }

  onEnterCompleted() {
    super.onEnterCompleted()
  }

  onLeave() {
    super.onLeave()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
  }

  resize() {
    super.resize()
  }

  scroll() {
    super.scroll()
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/Home.js